const EMBED_EMR = {
  AMWELL: 'Amwell'
}

export { EMBED_EMR }
